var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-polygon',{ref:"polygon",attrs:{"lat-lngs":_vm.selectionPolygon},on:{"click":function($event){return _vm.clearPolygon()}}})}
var staticRenderFns = []

export { render, staticRenderFns }